import * as Actions from '../../../store/orders/orders.actions';
import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';

const initialState = {
  jobIdtoJobMap: {},
  lastAddedJobId: '',
};

const updateBulkJobId = (state, bulkCancelJobId, pusherJobGuids, notificationId) => {
  const { jobIdtoJobMap } = state;
  const currentJob = jobIdtoJobMap[bulkCancelJobId];
  if (!currentJob) {
    return state;
  }
  return {
    ...state,
    jobIdtoJobMap: {
      ...jobIdtoJobMap,
      [bulkCancelJobId]: {
        ...currentJob,
        notificationId,
        pusherJobGuids: [...pusherJobGuids],
      },
    },
  };
};

const actionHandlerMap = {
  [Actions.UPDATE_BULK_CANCEL_JOB]: (state, { bulkCancelJobId, pusherJobGuids, notificationId }) => {
    return updateBulkJobId(state, bulkCancelJobId, pusherJobGuids, notificationId);
  },
  [Actions.DELETE_BULK_CANCEL_JOB]: (state, { bulkCancelJobId }) => {
    const { jobIdtoJobMap } = state;
    const clonedJobIdToJobMap = { ...jobIdtoJobMap };
    delete clonedJobIdToJobMap[bulkCancelJobId];
    return {
      ...state,
      jobIdtoJobMap: clonedJobIdToJobMap,
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './bulk.cancel.reducer.metadata';
